class NetworkRequest {
  constructor() {
    this.baseURL = this.getBaseURL();
  }

  getBaseURL() {
    // dev 与 production 统一使用相对路径 /api：
    // 由本地 devServer 代理 / 部署服务器（Nginx）做反向代理转发到后端。
    // 若生产写成绝对域名（如 https://api.mini.roadlinkglb.com），部署后浏览器会跨域直连后端，
    // 而后端未开放该站点域名的 CORS，OPTIONS 预检会被 403（Invalid CORS request）拦截。
    // 走同源 /api 则不跨域、无预检，与 ContactsUs 表单的 /api 调用保持一致。
    return '/api';
  }

  async request(url, options = {}) {
    // 规范化拼接：剥离 baseURL 末尾斜杠与 url 开头斜杠，中间只补一个 /
    // 避免 baseURL 无结尾斜杠 + url 无开头斜杠时拼出 "...comzjs/..." 这种畸形地址
    const base = String(this.baseURL || '').replace(/\/+$/, '');
    const path = String(url || '').replace(/^\/+/, '');
    const fullURL = `${base}/${path}`;
    
    const defaultOptions = {
      headers: {
        'Content-Type': 'application/json',
      },
    };

    const config = {
      ...defaultOptions,
      ...options,
      headers: {
        ...defaultOptions.headers,
        ...options.headers,
      },
    };

    try {
      const response = await fetch(fullURL, config);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Network request failed:', error);
      throw error;
    }
  }

  async get(url, options = {}) {
    return this.request(url, {
      method: 'GET',
      ...options,
    });
  }

  async post(url, data, options = {}) {
    return this.request(url, {
      method: 'POST',
      body: JSON.stringify(data),
      ...options,
    });
  }

  // 添加重试机制
  async getWithRetry(url, retries = 3, delay = 1000, options = {}) {
    try {
      return await this.get(url, options);
    } catch (error) {
      if (retries > 0) {
        console.log(`Retrying request... ${retries} attempts left`);
        await new Promise(resolve => setTimeout(resolve, delay));
        return this.getWithRetry(url, retries - 1, delay * 2, options);
      } else {
        throw error;
      }
    }
  }
}

// 创建单例实例
const networkRequest = new NetworkRequest();

export default networkRequest;